import * as React from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faKey, faPrint} from "@fortawesome/free-solid-svg-icons";
import {PrinterTab} from "./Tabs/PrinterTab";
import {observable} from "mobx";

import {LicenseTab} from "./Tabs/LicenseTab";

import {StoreBase} from "shared/utilities/Store/StoreBase";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {ToastService} from "shared/utilities/services/ToastService";

library.add(faPrint);
library.add(faKey);
export class App extends React.Component<AppProps, AppState> {
    static defaultProps: Partial<AppProps> = {};
    private store:SettingsStore;
    constructor(props: AppProps) {
        super(props);
        WpAjaxPost.SetGlobalVar(rednaoSettingsParams);
        this.state = {
            IsBusy:false
        };
        this.store=new SettingsStore().Merge();
      //  this.store.Load({Printer:{...rednaoSettingsParams.PrinterToken,DefaultPrinter:rednaoSettingsParams.DefaultPrinter}});

        this.store.Merge({Printer:{...rednaoSettingsParams.PrinterToken,DefaultPrinter:rednaoSettingsParams.DefaultPrinter},License:{LicenseKey:rednaoSettingsParams.LicenseKey}});
    }

    public render() {
        return (
            <div className={'rednao'} style={{padding:10}}>
                <SpinnerButton IsBusy={this.state.IsBusy} OnClick={()=>this.Save()} >Save</SpinnerButton>
                <Tabs styles={{marginTop:10}}>
                    <Tabs.Item Id={'License'} Title={'License'} Icon={<FontAwesomeIcon icon={"key"}/>}>
                        <LicenseTab store={this.store.License} />
                    </Tabs.Item>
                    <Tabs.Item Id={"Printer"} Title={'Printer'} Icon={<FontAwesomeIcon icon={"print"}/>}>
                        <PrinterTab store={this.store.Printer}/>
                    </Tabs.Item>
                </Tabs>

            </div>
        )
    }

    private async Save() {
        this.setState({IsBusy:true});
        let result=await WpAjaxPost.Post('save_settings',this.store.ToObject());
        this.setState({IsBusy:false});
        if(result!=null)
            ToastService.SendSuccess('Settings saved successfully');
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AppProps {

}



interface AppState {
    IsBusy:boolean;
}

export class SettingsStore extends StoreBase{
    Printer:PrinterStore;
    License:LicenseStore;


    protected LoadDefaultValues() {
        this.Printer=new PrinterStore().Merge();
        this.License=new LicenseStore().Merge();
    }



}

export class LicenseStore extends StoreBase{
    @observable LicenseKey;
    protected LoadDefaultValues() {
        this.LicenseKey='';

    }

}

export class PrinterStore extends StoreBase{
    @observable clientid:string;
    @observable clientsecret:string;
    @observable token:string;
    @observable refreshtoken:string;

    @observable DefaultPrinter:string;
    @observable DefaultPrinterLabel:string;


    protected LoadDefaultValues() {
        this.clientid='';
        this.clientsecret='';
        this.token='';
        this.DefaultPrinter='';
        this.refreshtoken='';
        this.DefaultPrinterLabel='';
    }

}

//#endregion "My Region"